import { OutlineButton } from '../display/button';
import React, { useEffect } from 'react';
import { useUrlTableState } from './table-state-persistence';
import { useStore } from '../../store/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilterSlash } from '@fortawesome/pro-light-svg-icons';

export function TableResetButtons() {
  const { clearGridState } = useUrlTableState();
  const urlTick = useStore(state => state.urlTick);
  const [enabled, setEnabled] = React.useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const compressedState = searchParams.get('state');
    const search = searchParams.get('search');
    if (compressedState || search) setEnabled(true);
  }, [urlTick]);

  if (!enabled) return null;

  return (
    <OutlineButton onClick={clearGridState}>
      <FontAwesomeIcon icon={faFilterSlash} />
      <div>Reset Table</div>
    </OutlineButton>
  );
}
